export default "__VITE_ASSET__749190d3__"